import React from 'react';
import { DimensionValue, StyleSheet } from 'react-native';
import { Skeleton } from 'react-native-skeletons';

interface TextProps {
  height?: DimensionValue;
  width?: DimensionValue;
}

export const SkeletonText: React.FC<TextProps> = ({
  width = '80%',
  height = 8,
}) => {
  return (
    <Skeleton
      borderRadius={8}
      count={1}
      height={height}
      style={styles.text}
      width={width}
    />
  );
};

const styles = StyleSheet.create({
  text: {
    marginVertical: 4,
  },
});
